import { render, staticRenderFns } from "./asideComponentMob.vue?vue&type=template&id=bc625a04&scoped=true"
import script from "./asideComponentMob.vue?vue&type=script&lang=js"
export * from "./asideComponentMob.vue?vue&type=script&lang=js"
import style0 from "./asideComponentMob.vue?vue&type=style&index=0&id=bc625a04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc625a04",
  null
  
)

export default component.exports